export var actionTypePrefix = '@@WixPortfolio';
export var reduxKey = '@@WixPortfolio';
//# sourceMappingURL=constants.js.map